import { render, staticRenderFns } from "./AppPower.vue?vue&type=template&id=0a1db0d6&scoped=true&"
import script from "./AppPower.vue?vue&type=script&lang=js&"
export * from "./AppPower.vue?vue&type=script&lang=js&"
import style0 from "./AppPower.vue?vue&type=style&index=0&id=0a1db0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1db0d6",
  null
  
)

export default component.exports